export enum CurrentTool {
  ADD_FIELD = 'ADD_FIELD',
  ADD_PAGE = 'ADD_PAGE',
  FIELD_SETTING = 'FIELD_SETTING',
  PAGE_SETTING = 'PAGE_SETTING',
  SECTION_SETTING = 'SECTION_SETTING',
}
